var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardicon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2166_1209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1338 28.3662L26.9587 25.1912C27.6138 24.2025 28 23.0212 28 21.75C28 18.3037 25.1963 15.5 21.75 15.5C18.3037 15.5 15.5 18.3037 15.5 21.75C15.5 25.1963 18.3037 28 21.75 28C23.0212 28 24.2025 27.6138 25.1912 26.9587L28.3662 30.1338C28.61 30.3775 28.93 30.5 29.25 30.5C29.57 30.5 29.89 30.3775 30.1338 30.1338C30.6225 29.645 30.6225 28.855 30.1338 28.3662ZM18 21.75C18 19.6825 19.6825 18 21.75 18C23.8175 18 25.5 19.6825 25.5 21.75C25.5 23.8175 23.8175 25.5 21.75 25.5C19.6825 25.5 18 23.8175 18 21.75ZM14.25 18C14.25 18.69 13.69 19.25 13 19.25H11.125C10.7937 19.25 10.475 19.1187 10.2413 18.8837L9.3575 18H4.25C3.56125 18 3 18.5613 3 19.25C3 19.9387 3.56125 20.5 4.25 20.5H11.75C12.44 20.5 13 21.06 13 21.75C13 22.44 12.44 23 11.75 23H4.25C2.1825 23 0.5 21.3175 0.5 19.25C0.5 17.6225 1.54875 16.2475 3 15.73V6.75C3 3.30375 5.80375 0.5 9.25 0.5H21.75C25.1963 0.5 28 3.30375 28 6.75V13C28 13.69 27.44 14.25 26.75 14.25C26.06 14.25 25.5 13.69 25.5 13V6.75C25.5 4.6825 23.8175 3 21.75 3H9.25C7.1825 3 5.5 4.6825 5.5 6.75V15.5H9.875C10.2063 15.5 10.525 15.6313 10.7587 15.8663L11.6425 16.75H13C13.69 16.75 14.25 17.31 14.25 18Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2166_1209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon3);
export default __webpack_public_path__ + "static/media/cardicon3.2673c6ba120544584c3e9f435a4df3d7.svg";
export { ForwardRef as ReactComponent };